import axios from 'axios';

interface MeatexData {
    nonce: string;
}
declare const meatexData: MeatexData;

export default function submitForm(values, setJourney, setLoading, setProfileUrl) {
    let formData = new FormData();
    let url = '/wp-json/meatex/v1/marketplace/products';

    for (const key in values) {
        if (key !== 'images') {
            formData.append(key, values[key]);
        } else {
            values[key].forEach((file) => {
                formData.append('images[]', file);
            });
        }
    }
    setLoading(true);
    axios.post(url, formData, {
        headers: {
            'X-WP-Nonce': meatexData.nonce,
            'Content-Type': 'multipart/form-data'
        }
    })
        .then(response => {
            setLoading(false);
            if (response.data.success) {
                setProfileUrl(response.data.profile_url);
                setJourney('success');
            } else {
                console.error('Submission failed:', response.data.message);
                alert(response.data.message);
            }
        })
        .catch(error => {
            setLoading(false);
            console.log(error)
            console.error('Error submitting form:', error.message);
            alert('An error occurred while submitting the form. Please try again.');
        });
}